import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, UntypedFormBuilder, Validators } from '@angular/forms'
import {
  AccountService,
  Integration,
  IntegrationConfig,
  capabilityToIntegrationConfigType,
} from 'src/app/account/services/account.service'

export interface UpsertIntegrationSettings {
  integrationId: string
  name: string
  config: IntegrationConfig
}

@Component({
  selector: 'edit-integration-dialog',
  templateUrl: './edit-integration-dialog.component.html',
  styleUrls: ['./edit-integration-dialog.component.scss'],
  standalone: false,
})
export class EditIntegrationDialogComponent implements OnInit {
  @Input() integration: Integration = null
  @Input() saving: boolean = false
  @Output() cancel = new EventEmitter<null>()
  @Output() save = new EventEmitter<Integration>()

  @HostListener('document:keydown.escape', ['$event'])
  onEscapeKeydown(event: KeyboardEvent): void {
    if (this.saving) return
    event.preventDefault()
    this.onCancelClick()
  }

  constructor(
    private accountService: AccountService,
    private formBuilder: FormBuilder
  ) {}

  integrationSettingsFormModel = this.formBuilder.group({
    integrationType: ['', Validators.required],
    integrationName: ['', Validators.required],
    integrationConfig: [null],
  })

  ngOnInit(): void {
    if (!!this.integration) {
      this.integrationSettingsFormModel.setValue({
        integrationType: this.integration.config.getIntegrationType(),
        integrationName: this.integration.name,
        integrationConfig: this.integration.config,
      })
    }
  }

  get entitledIntegrations() {
    let toReturn = Object.keys(capabilityToIntegrationConfigType)
      .filter((capability) => this.accountService.entitledForCapability(capability))
      .map((capability) => {
        let configType = capabilityToIntegrationConfigType[capability]
        return {
          integrationType: configType.integrationType,
          displayString: configType.typeDisplayString,
        } as { integrationType: string; displayString: string }
      })
    return toReturn
  }

  onCancelClick() {
    this.cancel.emit(null)
  }

  onSaveClick() {
    let newIntegration = new Integration(
      !!this.integration ? this.integration.integrationId : null,
      this.integrationSettingsFormModel.value.integrationName,
      this.integrationSettingsFormModel.value.integrationConfig
    )

    this.save.emit(newIntegration)
  }

  get valid() {
    return this.integrationSettingsFormModel.valid
  }

  get integrationDisplayString() {
    return this.integration.config.getTypeDisplayString
  }
}
